import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SIGNATURE_REGIMES } from "@/domain/investor";
import type { RepresentativeLabels } from "@/domain/types/representative";
import { createRepresentativeValidationMessages } from "@/domain/validation/representativeSchemas";

export function useRepresentativeLabels(): RepresentativeLabels {
  const { t } = useTranslation();
  return useMemo(
    () => ({
      title: t("representatives.title"),
      add: t("representatives.add_title"),
      addDescription: (company: string) => t("representatives.add_description", { company }),
      create: t("representatives.add"),
      cancel: t("common.cancel"),
      fullName: t("representatives.full_name"),
      fullNamePlaceholder: t("representatives.full_name_placeholder"),
      dni: t("representatives.dni"),
      dniPlaceholder: t("representatives.dni_placeholder"),
      position: t("representatives.position"),
      positionOf: t("representatives.position_of"),
      phone: t("representatives.phone"),
      phonePlaceholder: t("representatives.phone_placeholder"),
      email: t("representatives.email"),
      emailPlaceholder: t("representatives.email_placeholder"),
      validation: createRepresentativeValidationMessages(t),
      newRepresentative: t("representatives.new"),
      fallbackName: t("representatives.one"),
      noData: t("representatives.no_data"),
      edit: t("representatives.edit"),
      collapse: t("representatives.collapse"),
      delete: t("common.delete"),
      actions: (name: string) => t("representatives.actions", { name }),
      deleteTitle: (name: string) => t("representatives.delete_title", { name }),
      deleteSigner: t("representatives.delete_signer"),
      deleteDescription: t("representatives.delete_description"),
      deleted: t("representatives.deleted"),
      regimeTitle: t("representatives.regime_title"),
      regime: t("representatives.regime"),
      regimeDescription: t("representatives.regime_description"),
      regimes: SIGNATURE_REGIMES.map((value) => ({
        value,
        label: t(`representatives.regime_${value}`),
      })),
      whoSigns: t("representatives.who_signs"),
      twoSigners: t("representatives.two_signers"),
      oneSigner: t("representatives.one_signer"),
      addOne: t("representatives.add_one"),
      jointWarning: t("representatives.joint_warning"),
    }),
    [t],
  );
}
